













































































































































































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, MixinUpload} from 'simpli-web-sdk'
import {FileObject} from 'image-compressor.js'
import {DeliveryRegisterState} from '@/enums/DeliveryRegisterState'
import {UploadConfig} from '@/config/upload.config'
import * as Helper from '@/helpers'
import {Getter} from 'vuex-class'
import Responsavel from '@/model/resource/Responsavel'

@Component
export default class ModalDeliveryRegister extends Mixins(MixinUpload) {
  @Getter('auth/responsavel') user!: Responsavel

  DeliveryRegisterState = DeliveryRegisterState

  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset()

  state: DeliveryRegisterState | null = null
  showNotificacaoSmsAtlas = Helper.getShowNotificacaoSmsAtlas()
  showNotificationEmailAtlas = Helper.getShowNotificacaoEmailAtlas()
  showPrevisaoReal = Helper.getPermitirDataReal()

  @Watch('files')
  async filesEvent(filesObject: FileObject[]) {
    if (!filesObject.length) return

    $.await.init('uploading-file')

    const files = filesObject.map((item) => item.file)

    if (this.state === DeliveryRegisterState.EXPECTED_DATE) {
      try {
        await Helper.persistSLA(files)
        this.$emit('successSla')
        this.$emit('success')
      } catch (e) {
        this.$emit('failSla')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.MULTIPLE_WITH_DANFE) {
      try {
        await Helper.persistWithDanfe(files)
        this.$emit('successWithDanfe')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithDanfe')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.MULTIPLE_WITHOUT_DANFE) {
      try {
        await Helper.persistWithoutDanfe(files)
        this.$emit('successWithoutDanfe')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithoutDanfe')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.MULTIPLE_WITH_NOTFIS) {
      try {
        await Helper.persistWithNotfis(files)
        this.$emit('successWithNotfis')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithNotfis')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.MULTIPLE_WITH_CTE) {
      try {
        await Helper.persistWithCTE(files, false, this.user.emitenteTransportador)
        this.$emit('successWithCTE')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithCTE')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.MULTIPLE_WITH_CTE_READ_NF) {
      try {
        await Helper.persistWithCTE(files, true, this.user.emitenteTransportador)
        this.$emit('successWithCTEReadNf')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithCTEReadNf')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.ORDER_NUMBER) {
      try {
        await Helper.persistOrderNumber(files)
        this.$emit('successWithOrderNumber')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithOrderNumber')
        this.$emit('fail')
      }
    } else if (this.state === DeliveryRegisterState.ISSUE_DATE) {
      try {
        await Helper.persistIssueDate(files)
        this.$emit('successWithIssueDate')
        this.$emit('success')
      } catch (e) {
        this.$emit('failWithIssueDate')
        this.$emit('fail')
      }
    }

    this.files = []
    $.await.done('uploading-file')
    this.$emit('refresh')
  }

  get title() {
    if (this.state === DeliveryRegisterState.EXPECTED_DATE) {
      return $.t('modal.deliveryRegister.title.expectedDate')
    }
    if (this.state === DeliveryRegisterState.ORDER_NUMBER) {
      return $.t('modal.deliveryRegister.title.orderNumber')
    }
    if (this.state === DeliveryRegisterState.ISSUE_DATE) {
      return $.t('modal.deliveryRegister.title.issueDate')
    }
    if (this.state === DeliveryRegisterState.MULTIPLE_WITH_DANFE) {
      return $.t('modal.deliveryRegister.title.multipleWithDanfe')
    }
    if (this.state === DeliveryRegisterState.MULTIPLE_WITHOUT_DANFE) {
      return $.t('modal.deliveryRegister.title.multipleWithoutDanfe')
    }
    if (this.state === DeliveryRegisterState.MULTIPLE_WITH_NOTFIS) {
      return $.t('modal.deliveryRegister.title.multipleWithNotfis')
    }
    return ''
  }

  close() {
    this.$modal.close('deliveryRegister')
  }

  openEvent(state: DeliveryRegisterState | null) {
    if (state === null) {
      this.close()
    }

    this.state = state
    this.files = []
    this.$emit('open')
  }

  closeEvent() {
    this.state = null
    this.files = []
    this.$emit('close')
  }

}
